<template>
  <div v-if="isDesktop" class="space-x-4 flex mb-4">
    <div class="flex-1 min-w-0 space-y-4">
      <OvTreasuryBox
        v-if="daoPageInfo.vueState.info.dashboardIsOpen"
        :type="daoPageInfo.vueState.info.displayType"
        :isUsdt="isUsdt"
      ></OvTreasuryBox>
      <OvDappBox v-if="daoPageInfo.vueState.info.dashboardIsOpen"></OvDappBox>
      <OvPassBox></OvPassBox>
      <OvTwMirror></OvTwMirror>
    </div>
    <div class="space-y-4" style="width: 384px">
      <OvComprehensiveBox></OvComprehensiveBox>
      <OvGovernanceBox
        v-if="daoPageInfo.vueState.info.hasGovernanceToken"
      ></OvGovernanceBox>
      <OvProposal v-if="daoPageInfo.vueState.info.hasGovernance"></OvProposal>
      <OvStructure v-if="daoPageInfo.vueState.info.structure"></OvStructure>
    </div>
  </div>
  <div v-if="!isDesktop">
    <div class="space-y-4">
      <OvTreasuryBox
        v-if="daoPageInfo.vueState.info.dashboardIsOpen"
        :type="daoPageInfo.vueState.info.displayType"
        :isUsdt="isUsdt"
      ></OvTreasuryBox>
      <OvDappBox v-if="daoPageInfo.vueState.info.dashboardIsOpen"></OvDappBox>
      <OvPassBox></OvPassBox>

      <OvComprehensiveBox></OvComprehensiveBox>
      <OvGovernanceBox
        v-if="daoPageInfo.vueState.info.hasGovernanceToken"
      ></OvGovernanceBox>
      <OvProposal v-if="daoPageInfo.vueState.info.snapshotUrl"></OvProposal>
      <OvStructure v-if="daoPageInfo.vueState.info.structure"></OvStructure>
      <OvTwMirror></OvTwMirror>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import OvPassBox from './components/OvPassBox.vue';
import OvComprehensiveBox from './components/OvComprehensiveBox.vue';
import OvGovernanceBox from './components/OvGovernanceBox.vue';
import OvTreasuryBox from './components/OvTreasuryBox.vue';
import OvDappBox from './components/OvDappBox.vue';
import OvTwMirror from './components/OvTwMirror.vue';
import OvStructure from './components/OvStructure.vue';
import OvProposal from './components/OvProposal.vue';
import { checkScreenSize } from '@/hooks';
const isDesktop = checkScreenSize();
const daoPageInfo = inject('daoPageInfo');
const isUsdt = computed(() => daoPageInfo.vueState.byUnit.value == 'USDT');
</script>

<style lang="scss" scoped></style>
